import { post } from '@/utils/request'

/**
 * 推荐内容增加
 * @param {String} url url
 * @param {String} picture 图片路径（请先用pciture_add上传）
 * @param {String} type 推荐类别 默认“CMS首页推荐”
 */
export function admin_cms_banner_recommend_add(data) {
  return post('admin_cms_banner_recommend_add', data)
}

/**
 * 推荐内容删除 
 * @param {String} id id
 */
export function admin_cms_banner_recommend_delete(data) {
  return post('admin_cms_banner_recommend_delete', data)
}

/**
 * 推荐内容修改  
 * @param {String} id id
 * @param {String} picture 图片路径（请先用pciture_add上传）
 * @param {String} type 推荐类别 默认“CMS首页推荐”
 */
export function admin_cms_banner_recommend_edit(data) {
  return post('admin_cms_banner_recommend_edit', data)
}

/**
 * 推荐内容列表
 * @param {String} type 推荐类别 默认“CMS首页推荐”
 */
export function admin_cms_banner_recommend_list(data) {
  return post('admin_cms_banner_recommend_list', data)
}

/**
 * 推荐内容修改排序 
 * @param {String} id_order_str id排序逗号隔开 比如 2,3,1,45
 */
export function admin_cms_banner_recommend_order_set(id_order_str) {
  return post('admin_cms_banner_recommend_order_set', { id_order_str })
}




/**
 * 推荐内容增加
 * @param {String} url url
 * @param {String} picture 图片路径（请先用pciture_add上传）
 * @param {String} type 推荐类别 默认“CMS首页推荐”
 */
export function taoke_cms_banner_recommend_add(data) {
  return post('taoke_cms_banner_recommend_add', data)
}

/**
 * 推荐内容删除 
 * @param {String} id id
 */
export function taoke_cms_banner_recommend_delete(data) {
  return post('taoke_cms_banner_recommend_delete', data)
}

/**
 * 推荐内容修改  
 * @param {String} id id
 * @param {String} picture 图片路径（请先用pciture_add上传）
 * @param {String} type 推荐类别 默认“CMS首页推荐”
 */
export function taoke_cms_banner_recommend_edit(data) {
  return post('taoke_cms_banner_recommend_edit', data)
}

/**
 * 推荐内容列表
 * @param {String} type 推荐类别 默认“CMS首页推荐”
 */
export function taoke_cms_banner_recommend_list(data) {
  return post('taoke_cms_banner_recommend_list', data)
}

/**
 * 推荐内容修改排序 
 * @param {String} id_order_str id排序逗号隔开 比如 2,3,1,45
 */
export function taoke_cms_banner_recommend_order_set(id_order_str) {
  return post('taoke_cms_banner_recommend_order_set', { id_order_str })
}